import { OnInit, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Selectors, Actions } from 'store/root-reducer';
import { TableNameType, TablePreferenceType } from 'modules/shared/models/table-preference.models';
import { TasksService } from 'modules/dashboard/services/tasks.service';
import { SnackbarService } from 'app/services/snackbar.service';
var TaskTableComponent = /** @class */ (function () {
    function TaskTableComponent(cdRef, taskService, snackBar, store) {
        this.cdRef = cdRef;
        this.taskService = taskService;
        this.snackBar = snackBar;
        this.store = store;
        this.unsubscribe$ = new Subject();
        this.displayedColumns = ['name', 'type', 'date'];
        this.pageSizeOptions = [5, 10, 15];
        this.isLoading = false;
        this.isActive = 'type';
        this.tasksDataSource = new MatTableDataSource([]);
        this.preferredTaskTablePageSize = this.pageSizeOptions[0];
        this.currentPage = 0;
        this.tableNameType = '';
        this.showErrorIcon = false;
    }
    Object.defineProperty(TaskTableComponent.prototype, "sort", {
        set: function (sort) {
            this.tasksDataSource.sort = sort;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskTableComponent.prototype, "paginator", {
        set: function (paginator) {
            this.tasksDataSource.paginator = paginator;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaskTableComponent.prototype, "taskType", {
        set: function (type) {
            if (type) {
                this.currentTasksType = type;
                if (type === 'overdue') {
                    this.showErrorIcon = true;
                }
                this.tableNameType = type.toUpperCase() + '_TASK_TABLE';
                this.getTaskTablePreference();
            }
        },
        enumerable: true,
        configurable: true
    });
    TaskTableComponent.prototype.ngOnInit = function () {
    };
    /**
     * Get table pagination preference from store
     * @method getTaskTablePreference
     */
    TaskTableComponent.prototype.getTaskTablePreference = function () {
        var _this = this;
        this.store.select(Selectors.userPreference.getTablesPreference)
            .pipe(takeUntil(this.unsubscribe$), take(1))
            .subscribe(function (tablesPreference) {
            var tablePreference = tablesPreference[TableNameType[_this.tableNameType]];
            if (tablePreference) {
                if (tablePreference[TablePreferenceType.PAGE_SIZE]) {
                    _this.preferredTaskTablePageSize = tablePreference[TablePreferenceType.PAGE_SIZE];
                }
                if (tablePreference[TablePreferenceType.SORT]) {
                    _this.tasksDataSource.sort.active = tablePreference[TablePreferenceType.SORT].active;
                    _this.tasksDataSource.sort.direction = tablePreference[TablePreferenceType.SORT].direction;
                }
                _this.cdRef.detectChanges();
            }
            _this.getTasks();
        });
    };
    /**
       * Get page with (pending, overdue case)
       * @method getTasks
       */
    TaskTableComponent.prototype.getTasks = function () {
        var _this = this;
        this.isLoading = true;
        this.cdRef.detectChanges();
        this.taskService
            .getTasks(this.currentTasksType, {
            limit: this.preferredTaskTablePageSize,
            offset: this.preferredTaskTablePageSize * this.currentPage,
            sort: this.currentTableSort
        })
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(function (documentsRes) {
            _this.preferredTaskTableDataSourceLength = documentsRes.count;
            if (_this.tasksDataSource) {
                _this.tasksDataSource.data = documentsRes.results;
            }
            else {
                _this.tasksDataSource = new MatTableDataSource(documentsRes.results);
            }
            _this.tasksDataSource.paginator = _this.paginator;
            _this.isLoading = false;
            _this.cdRef.detectChanges();
        }, function (error) {
            _this.isLoading = false;
            _this.snackBar.error('Error: Failed to load list of tasks');
            _this.cdRef.detectChanges();
        });
    };
    /**
     * Pagination event handler
     * @method tablePaginationChangeHandler
     */
    TaskTableComponent.prototype.tablePaginationChangeHandler = function (event) {
        if (event.pageSize !== this.preferredTaskTablePageSize) {
            this.store.dispatch(new Actions.userPreference.SetPaginationPreference({ tableName: TableNameType[this.tableNameType], pageSize: event.pageSize }));
            this.preferredTaskTablePageSize = event.pageSize;
        }
        this.currentPage = event.pageIndex;
        this.getTasks();
    };
    /**
     * Add sort information to preference store
     * @method tableSortChangeHandler
     */
    TaskTableComponent.prototype.tableSortChangeHandler = function (event) {
        var _a;
        this.store.dispatch(new Actions.userPreference.SetSortPreference((_a = {
                tableName: TableNameType[this.tableNameType]
            },
            _a[TablePreferenceType.SORT] = {
                active: event.active,
                direction: event.direction
            },
            _a)));
        switch (event.direction) {
            case 'asc':
                this.currentTableSort = "" + event.active;
                break;
            case 'desc':
                this.currentTableSort = "-" + event.active;
                break;
            default:
                this.currentTableSort = undefined;
                break;
        }
        this.getTasks();
    };
    return TaskTableComponent;
}());
export { TaskTableComponent };
